import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type SheetTitleProps = SheetPrimitive.Title.Props;

const SheetTitle = ({ className, ...props }: SheetTitleProps) => {
  return (
    <SheetPrimitive.Title
      data-slot="sheet-title"
      className={cn('text-base font-semibold text-gray-900', className)}
      {...props}
    />
  );
};

export default SheetTitle;
